<template>
  <div class="aaaaa">

    <div class="bbbbb">

    <!-- 头部部分 -->
    <div ref="search_d">
      <el-row type="flex" class="row-bg" >
        <el-form label-width="90px" label-height="60px" :model="queryInfo.condition" class="demo-form-inline">

          <el-col :span="8">
            <el-form-item label="客户昵称">
              <el-input style="width: 100%;" v-model="queryInfo.condition.memberName" placeholder="客户昵称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货人名称">
              <el-input style="width: 100%;" v-model="queryInfo.condition.recipientName" placeholder="收货人名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="收货人号码">
              <el-input style="width: 100%;" v-model="queryInfo.condition.recipientPhone"
                placeholder="收货人号码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="订单号">
              <el-input style="width: 100%;" v-model="queryInfo.condition.orderNumber" placeholder="订单号"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label-width="20px">
              <el-button type="primary" @click="getList" icon="el-icon-search">查询</el-button>
              <el-button type="primary" @click="reset">重置</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>

    <!-- 表格部分 -->
    <div>
      <el-table border ref="table" :data="tableData" tooltip-effect="dark" style="width: 100%" :height="height">
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>

        <!-- <el-table-column label="用户名称" align="center" width="100px" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.memberName }}</template>
</el-table-column>
<el-table-column label="用户头像" align="center" width="80px" show-overflow-tooltip>
  <template slot-scope="scope">
              <el-avatar shape="square" :size="50" :src="scope.row.memberLogo"></el-avatar>
            </template>
</el-table-column> -->
        <!-- <el-table-column label="支付单号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.payNo }}</template>
          </el-table-column> -->
        <el-table-column label="订单号" width="180px" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderNumber }}</template>
        </el-table-column>
        <el-table-column label="商品名称" width="180px" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.productNames }}</template>
        </el-table-column>
        <el-table-column label="订单金额/元" width="120px" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderAmount }}</template>
        </el-table-column>
        <el-table-column label="实付金额/元" width="120px" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderAmount }}</template>
        </el-table-column>
        <el-table-column label="商品图片" align="center" width="180px" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-avatar shape="square" v-for="img in scope.row.imgList" v-bind:key="img" :size="50"
              :src="img"></el-avatar>
          </template>
        </el-table-column>
        <!-- <el-table-column label="供应商编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.supplierCode }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="供应商名称" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.supplierName }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="站点编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.siteCode }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="所属站点" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.siteName }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="所属团长编码" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.teamCode }}</template>
          </el-table-column> -->
        <!-- <el-table-column label="所属团长" align="center" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.teamName }}</template>
          </el-table-column> -->
<!--        <el-table-column label="订单所属" align="center" show-overflow-tooltip>-->
<!--          <template slot-scope="scope">{{ scope.row.goodSourceType == 1 ? '平台' : '供应商' }}</template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="供应商名称" width="150" align="center" show-overflow-tooltip>-->
<!--          <template slot-scope="scope">{{ scope.row.supplierName }}</template>-->
<!--        </el-table-column>-->

        <el-table-column label="下单时间"   align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.orderTime }}</template>
        </el-table-column>
        <el-table-column label="操作" width="235" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="showOrderItemInfo(scope.row)" size="small">查看详情</el-button>
            <el-button type="text" v-if="scope.row.goodSourceType === 1" @click="printOrder(scope.row)"
              size="small">打印小票</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage" :page-sizes="[100, 200, 300, 400]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    </div>
    <el-dialog :title="(labelType == 'add' ? '新增' : '编辑')" :visible.sync="showDialog" width="800px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="10">

          <el-col :span="12">
            <el-form-item label="：" prop="siteName">
              <el-input v-model="form.id" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户编码：" prop="siteName">
              <el-input v-model="form.memberCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名称：" prop="siteName">
              <el-input v-model="form.memberName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户头像：" prop="siteName">
              <el-input v-model="form.memberLogo" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="支付单号：" prop="siteName">
              <el-input v-model="form.payNo" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单号：" prop="siteName">
              <el-input v-model="form.orderNumber" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单金额：" prop="siteName">
              <el-input v-model="form.orderAmount" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商编码：" prop="siteName">
              <el-input v-model="form.supplierCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商名称：" prop="siteName">
              <el-input v-model="form.supplierName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="站点编码：" prop="siteName">
              <el-input v-model="form.siteCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="站点名称：" prop="siteName">
              <el-input v-model="form.siteName" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属团长编码：" prop="siteName">
              <el-input v-model="form.teamCode" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="：" prop="siteName">
              <el-input v-model="form.teamCod" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="showDialog = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSave">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="订单详情" :visible.sync="dialogOrderItemVisible" class="info_dialog" top="10vh">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!-- <el-tab-pane label="订单详情" name="first">
          <el-container>
            <el-header>买家信息</el-header>
            <el-main><div>用户头像:<span> <el-avatar shape="square" :size="50" :src="orderInfo.memberLogo"></el-avatar></span></div></el-main>
            <el-main><div>用户名称:<span>{{orderInfo.memberName}}</span></div></el-main>
            <el-main><div>用户手机号:<span>{{orderInfo.memberPhone}}</span></div></el-main>
            <el-main><div>收件人名称:<span>{{orderInfo.recipientName}}</span></div></el-main>
            <el-main><div>收件人手机号码:<span>{{orderInfo.recipientPhone}}</span></div></el-main>
            <el-main><div>收件人地址:<span>{{orderInfo.provinceName}}{{orderInfo.cityName}}{{orderInfo.expAreaName}}{{orderInfo.expressAddress}}</span></div></el-main>
          </el-container>
          <el-container>
            <el-header>团长信息</el-header>
            <el-main><div>团长名称:<span>{{orderInfo.teamName}}</span></div></el-main>
            <el-main><div>团长手机号码:<span>{{orderInfo.teamPhone}}</span></div></el-main>
          </el-container>

          <el-container>
            <el-header>订单信息</el-header>
            <el-main><div>订单号:<span>{{orderInfo.orderNumber}}</span></div></el-main>
            <el-main><div>支付方式:<span>{{getPayType(orderInfo.payType)}}</span></div></el-main>
            <el-main><div>实际付款:<span>{{orderInfo.actualAmount}}元</span></div></el-main>
            <el-main><div>下单时间:<span>{{orderInfo.orderTime}}</span></div></el-main>
            <el-main><div>支付时间:<span>{{orderInfo.orderTime}}</span></div></el-main>
          </el-container>

          <el-table :data="orderItemData">
            <el-table-column label="商品图片" width="150">
              <template slot-scope="scope">
                  <el-avatar shape="square" :size="50" :src="scope.row.listImg"></el-avatar>
                </template>
            </el-table-column>
            <el-table-column property="productName" label="商品名称" width="200"></el-table-column>
            <el-table-column property="sellPrice" label="售卖价"></el-table-column>
            <el-table-column property="count" label="数量"></el-table-column>
            <el-table-column property="skuName" label="规格"></el-table-column>
            <el-table-column label="总价">
              <template slot-scope="scope">
                  {{scope.row.count*scope.row.sellPrice}}
                </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="订单进度" name="second">
          <el-table :data="orderProgressData">

            <el-table-column property="orderProgressName" label="进度" width="200"></el-table-column>
            <el-table-column property="createTime" label="时间"></el-table-column>

          </el-table>

        </el-tab-pane> -->

        <el-tab-pane label="订单信息" name="first">
          <div class="info_box">
            <div class="info_status_box">
              <div class="info_status">当前订单状态：{{ orderInfo.saleAfterStatus == 0 &&
                orderInfo.refundStatus == 3 ? '取消订单' : orderStatusMap[orderInfo.orderStatus] }}</div>
              <div class="info_change_btn"><el-button size="mini" @click="openaddress" round>修改地址</el-button></div>
            </div>
            <div class="info_section">
              <div class="info_section_header">买家信息</div>
              <div class="info_section_cnt">
                <el-row :gutter="10">
                  <el-col :span="8">
                    用户头像:
                    <span class="info_section_span">
                      <el-avatar shape="square" :size="50" :src="orderInfo.memberLogo"></el-avatar></span>
                  </el-col>
                  <el-col :span="8">
                    用户名称:<span class="info_section_span">{{ orderInfo.memberName }}</span>
                  </el-col>
                  <!-- <el-col :span="8">
                    用户手机号:<span class="info_section_span">{{ orderInfo.memberPhone }}</span>
                  </el-col> -->
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    收件人名称:<span class="info_section_span">{{ orderInfo.recipientName }}</span>
                  </el-col>
                  <el-col :span="8">
                    收件人手机号码:<span class="info_section_span">{{ orderInfo.recipientPhone }}</span>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="24">
                    收件人地址:<span class="info_section_span">{{ orderInfo.expAreaDetail + orderInfo.expressAddress
                      }}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="info_section">
              <div class="info_section_header">订单信息</div>
              <div class="info_section_cnt">
                <el-row :gutter="10">
                  <el-col :span="8">
                    订单号:<span class="info_section_span">{{ orderInfo.orderNumber }}</span>
                  </el-col>
                  <el-col :span="8">
                    支付方式:<span class="info_section_span">{{ getPayType(orderInfo.payType) }}</span>
                  </el-col>
                  <el-col :span="8">
                    实际付款:<span class="info_section_span">{{ orderInfo.actualAmount }}元</span>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    下单时间:<span class="info_section_span">{{ orderInfo.orderTime }}</span>
                  </el-col>
                  <el-col :span="8">
                    支付时间:<span class="info_section_span">{{ orderInfo.orderTime }}</span>
                  </el-col>
                  <el-col :span="24">
                    订单备注:<span class="info_section_span">{{ orderInfo.remark }}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="info_goods_table">
              <el-table :data="orderItemData">
                <el-table-column label="商品图片" width="150">
                  <template slot-scope="scope">
                    <el-avatar shape="square" :size="50" :src="scope.row.listImg"></el-avatar>
                  </template>
                </el-table-column>
                <el-table-column property="productName" label="商品名称" width="200"></el-table-column>
                <el-table-column property="sellPrice" label="单价"></el-table-column>
                <el-table-column property="count" label="数量"></el-table-column>
                <el-table-column property="skuName" label="规格"></el-table-column>
                <el-table-column label="配送方式">
                  <template slot-scope="scope">
                    {{ getDelivery(scope.row) }}
                  </template>
                </el-table-column>
                <!-- <el-table-column property="skuName" label="优惠"></el-table-column> -->
                <el-table-column label="总价">
                  <template slot-scope="scope">
                    {{ scope.row.count * scope.row.sellPrice }}
                  </template>
                </el-table-column>
                <el-table-column property="actualAmount" label="实付"></el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="团长信息" name="second">
          <div class="info_box">
            <div class="info_section">
              <div class="info_section_header">团长信息</div>
              <div class="info_section_cnt">
                <el-row :gutter="10">
                  <el-col :span="8">
                    团长头像:
                    <span class="info_section_span">
                      <el-avatar shape="square" :size="50" :src="orderInfo.memberLogo"></el-avatar></span>
                  </el-col>
                  <el-col :span="8">
                    团长昵称:<span class="info_section_span">{{ orderInfo.memberName }}</span>
                  </el-col>
                  <el-col :span="8">
                    团长名称:<span class="info_section_span">{{ orderInfo.teamName }}</span>
                  </el-col>
                  <el-col :span="24">
                    团长地址:<span class="info_section_span">{{ orderInfo.teamAddressTz }}</span>
                  </el-col>
                  <el-col :span="8">
                    团长手机号码:<span class="info_section_span">{{ orderInfo.teamPhone }}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="info_section">
              <div class="info_section_header">提货点信息</div>
              <div class="info_section_cnt">
                <el-row :gutter="10">
                  <el-col :span="8">
                    联系人姓名:<span class="info_section_span">{{ orderInfo.siteName }}</span>
                  </el-col>
                  <el-col :span="8">
                    提货点手机号:<span class="info_section_span">{{ orderInfo.siteName }}</span>
                  </el-col>
                  <el-col :span="8">
                    提货点名称:<span class="info_section_span">{{ orderInfo.siteName }}</span>
                  </el-col>
                  <el-col :span="24">
                    提货点地址:<span class="info_section_span">{{ orderInfo.teamAddress }}</span>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="订单进度" name="third">
          <el-table :data="orderProgressData">
            <el-table-column property="orderProgressName" label="进度" width="200"></el-table-column>
            <el-table-column property="createTime" label="时间"></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>

    </el-dialog>
  </div>
</template>

<script>
import MapComponent from '@/components/MapComponent/index.vue'
import { mapState } from 'vuex'
export default {
  components: { MapComponent },
  data () {
    return {
      labelType: 'add',
      rules: {},
      total: 0,
      queryInfo: {
        pageSize: 100,
        pageCount: 1,
        currPage: 1,
        condition: {}
      },
      form: {},
      showDialog: false,
      tableData: [],
      height: window.innerHeight - 256, // 表格高度
      headerHeight: 0,
      dialogOrderItemVisible: false,
      addressDialog: false,
      btnloading: false,
      orderInfo: {},
      setaddress: {},
      orderItemData: [],
      activeName: 'first',
      orderProgressData: '',
      orderStatusMap: {
        1: '待司机装车',
        2: '待司机配送',
        3: '司机配送中',
        4: '待团长签收',
        5: '待用户核销',
        6: '待团长配送',
        7: '已完成',
        8: '已评价'
      },
      getTypeMap: {
        1: '团长配送',
        2: '客户自提',
        3: '快递物流'
      }
    }
  },

  computed: {
    searchKeyword: {
      get () {
        return this.$store.state.main.searchKeyword
      },
      set (value) {
        this.$store.commit('main/changeSearchKeyword', value)
      }
    },
    ...mapState('main', [
      'longitude',
      'latitude',
      'provinceCode',
      'provinceName',
      'cityCode',
      'cityName',
      'areaCode',
      'areaName'
    ])
  },
  created () {
    this.getList()
  },

  mounted () {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight
      window.addEventListener('resize', this.getHeight())
    })
  },

  methods: {
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - this.headerHeight - 256
    },
    getDelivery (row) {
      // 是否门店自提
      if (row.isSelfPickup == 1) {
        return '门店自提'
      }
      // 是否专享配送
      if (row.isSelfPickup == 1) {
        return '专享配送'
      }
      // 是否快递配送
      if (row.isSelfPickup == 1) {
        return '快递配送'
      }
      // 团长配送
      if (row.isSelfPickup == 1) {
        return '团长配送'
      }
    },

    // 获取数据
    getList () {
      var that = this
      that.queryInfo.condition.type = 1
      that.$http.post('/order/manageList', that.queryInfo).then(function (response) {
        console.log(response.data.data)
        if (response.data.code == 200) {
          that.total = response.data.data.count
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data
        }
      })
    },

    // 保存
    handleSave () {
      var that = this
      that.$http.post('/order/save', that.form).then(function (response) {
        if (response.data.code == 200) {
          that.$notify.success({
            title: '提示',
            message: '保存成功',
            showClose: true
          })
          that.showDialog = false
          that.getList()
        } else {
          that.$notify.info({
            title: '提示',
            message: response.data.message,
            showClose: true
          })
        }
      }).catch(function (error) {

      })
    },

    // 修改
    edit (row) {
      this.showDialog = true
      this.labelType = 'edit'
      this.form = JSON.parse(JSON.stringify(row))
    },
    openaddress () {
      this.setaddress = JSON.parse(JSON.stringify(this.orderInfo))
      // 地图默认数据
      this.$store.commit('main/changeSearchKeyword', this.setaddress.expAreaDetail)
      this.$store.commit('main/changeLatitudeAndLongitude', {
        latitude: this.setaddress.latitude,
        longitude: this.setaddress.longitude
      })
      this.$store.commit('main/changeProvince', {
        provinceCode: this.setaddress.provinceCode,
        provinceName: this.setaddress.provinceName,
        cityCode: this.setaddress.cityCode,
        cityName: this.setaddress.cityName,
        areaCode: this.setaddress.areaCode,
        areaName: this.setaddress.areaName
      })
      this.addressDialog = true
      this.$refs.selectMap && this.$refs.selectMap.initMap()
    },
    saveaddress () {
      if (this.btnloading) {
        return
      }
      this.btnloading = true
      var that = this
      const _data = {
        // id: this.setaddress.id,
        orderNumber: this.setaddress.orderNumber,
        expAreaDetail: this.provinceName + this.cityName + this.areaName,
        expressAddress: this.setaddress.expressAddress,
        longitude: this.longitude,
        latitude: this.latitude,
        provinceCode: this.provinceCode,
        provinceName: this.provinceName,
        cityCode: this.cityCode,
        cityName: this.cityName,
        areaCode: this.areaCode,
        areaName: this.areaName
      }
      that.$http
        .post('/order/update', _data)
        .then(response => {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '修改成功',
              showClose: true
            })
            that.addressDialog = false
            that.orderInfo.expAreaDetail = _data.expAreaDetail
            that.orderInfo.expressAddress = _data.expressAddress
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
          that.btnloading = false
        })
        .catch(function (error) {
          that.btnloading = false
        })
    },
    // 删除当前行
    //    handleDelte (id) {
    //      del({ id: id }).then(res => {
    //        if (res.code == 200) {
    //         this.$message.success('删除成功')
    //         this.getList()
    //       }
    //      })
    //    },

    // 删除用户
    async handleDelte (id) {
      const confirmResult = await this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => err)
      if (confirmResult === 'confirm') {
        var that = this
        that.$http.post('/order/delete', { 'id': id }).then(function (response) {
          if (response.data.code == 200) {
            that.$notify.success({
              title: '提示',
              message: '删除成功',
              showClose: true
            })
            that.getList()
          } else {
            that.$notify.info({
              title: '提示',
              message: response.data.message,
              showClose: true
            })
          }
        })
      }
    },

    // 新增按钮
    newBtn () {
      this.labelType = 'add'
      this.showDialog = true
      this.form = {}
    },

    // 修改页数大小
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.getList()
    },

    // 获取当前页面
    handleCurrentChange (val) {
      this.queryInfo.currPage = val
      this.getList()
    },

    showOrderItemInfo (row) {
      this.dialogOrderItemVisible = true
      this.orderItemData = row.orderItems
      console.log('------订单详情----------')
      console.log(row)
      console.log('------订单详情----------')
      this.orderInfo = row
    },

    getPayType (patType) {
      if (patType === '1') {
        return '微信'
      } else if (patType === '2') {
        return '支付宝'
      } else if (patType === '3') {
        return '余额'
      } else if (patType === '4') {
        return '储值卡'
      } else if (patType === '1,5') {
        return '微信+积分'
      } else if (patType === '1,3') {
        return '微信+余额'
      } else if (patType === '1,4') {
        return '微信+储值卡'
      } else if (patType === '2,5') {
        return '支付宝+积分'
      } else if (patType === '2,3') {
        return '支付宝+余额'
      } else if (patType === '2,4') {
        return '支付宝+储值卡'
      } else if (patType === '3,5') {
        return '余额+积分'
      } else if (patType === '4,5') {
        return '储值卡+积分'
      } else if (patType === '6') {
        return '企业月付'
      }
    },
    handleClick (tab, event) {
      //   console.log("tab:",tab.name);
      // console.log("event:",event);
      // console.log(tab, event);
      if (tab.name === 'third') {
        this.getOrderProhress()
      }
    },

    /**
     * 获取订单进度
     *
     */
    getOrderProhress () {
      var that = this
      var data = {}
      data.orderNumber = this.orderInfo.orderNumber
      that.$http.post('/orderProgress/queryList', data).then(function (response) {
        console.log(response.data.data)
        if (response.data.code == 200) {
          that.orderProgressData = response.data.data
        }
      })
    },
    reset () {
      this.queryInfo.condition = {}
    },

    // 打印订单
    printOrder (row) {
      var that = this
      var data = {}
      data.id = row.id
      that.$http.post('/printer/printPlatformOrder', data).then(function (response) {
        console.log(response.data.data)
        if (response.data.code == 200) {
          that.$notify.success({
            title: '提示',
            message: '打印指令发送成功',
            showClose: true
          })
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.info_dialog {
  /deep/.el-dialog__body {
    padding: 5px 40px;
  }

  .info_box {
    width: 100%;
    height: 70vh;
    overflow-y: auto;
  }

  .info_status_box {
    width: 100%;
    padding: 10px 13px;
    box-sizing: border-box;
    background: #f2f9fd;
    border: 2px solid #8ecbeb;
    display: flex;
    flex-direction: column;

    .info_status {
      margin-bottom: 6px;
      color: #409EFF;
    }

    .info_change_btn {
      /deep/.el-button {
        font-size: 12px;
      }
    }
  }

  .info_section {
    width: 100%;
    padding: 10px 8px;
    box-sizing: border-box;

    .info_section_header {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .info_section_cnt {
      width: 100%;
      padding: 0 3px;
      box-sizing: border-box;

      .el-col {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
      }

      .info_section_span {
        padding-left: 14px;
      }
    }
  }
}
</style>
